import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { AccountService } from '@halo/services/account.service'
import { Container } from 'typescript-ioc/es5'
import { AccountDto } from '@halo/dtos/account.dto'
import { AccountBillingWell } from '@halo/components/account-data-form/account-billing-well'
import './style/account-data-form.scss'
import { AccountBillingHistoryWell } from '@halo/components/account-data-form/account-billing-history-well'
import { accountIsBillable } from '@halo/_utils/account'
import { AppState } from '@halo/stores/app.state'

interface IAccountBilling {
    className?: string
    accountId?: number
}

interface IAccountBillingState {
    account?: AccountDto
}

export class AccountBilling extends React.Component<IAccountBilling, IAccountBillingState> {
    protected appState: AppState
    protected accountService: AccountService

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.accountService = Container.get(AccountService)

        this.state = {}

        if (props.accountId) {
            this.fetchRequestedAccount()
        }
    }

    public render() {
        return (
            <div className={classnames('adf', this.props.className)}>
                <div className={classnames('adf-wrapper')}>
                    <AccountBillingWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />

                    {accountIsBillable(this.state.account) && (
                        <AccountBillingHistoryWell loading={this.isLoading} account={this.state.account} />
                    )}
                </div>
            </div>
        )
    }

    protected get isLoading(): boolean {
        return !this.state.account
    }

    protected handleAccountUpdated = async (updates: Partial<AccountDto>) => {
        this.setState(({ account }) => ({
            account: {
                ...account,
                ...updates,
            } as AccountDto,
        }))
    }

    protected async fetchRequestedAccount() {
        const account = await this.accountService.fetchById(this.props.accountId, {}, false)

        this.setState({ account })
    }
}
